import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Apirequests } from '../../utils/ApiRequests';
import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';
import SpinningLogo from '../../components/Spinner';
import CustomPageHeader from '../../components/CustomPageHeader';
import { downloadExcel } from '../../utils/DownloadXls';
import Table from '../../components/Table';
import BtnSpinner from '../../components/BtnSpinner';
import { Trash } from 'lucide-react';
import Pagination from '../../components/Pagination';
import moment from 'moment';
import CustomOffCanvas from '../../components/CustomOffCanvas';
import AddEqLead from './AddEqLead';

function EqTestLeads() {

    const [EqLeads, setEqLeads] = useState(null);
    const [loading, setLoading] = useState({ state: false, name: "" });
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [refresh, setRefresh] = useState(false);
    const [currenLead, setCurrenLead] = useState(null);
    const [deleteId, setdeleteId] = useState(null);
    const [isOffCanvasOpen, setIsOffCanvasOpen] = useState({ state: false, name: "" });


    const token = localStorage.getItem("token");


    const totalItems = EqLeads?.length; // Total number of items
    const itemsPerPage = 10;

    const currentData = EqLeads?.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const navigate = useNavigate();

    const handleRefresh = () => setRefresh(!refresh);

    const handleSearch = async () => {
        if (!searchTerm) {
            return ErrorTost("Enter a key to serach")
        }

        if (currentPage !== 1) {
            setCurrentPage(1)
        }

        await fetchLeads(searchTerm)
    };

    const fetchLeads = async () => {
        setLoading({ state: true, name: 'fetchleads' })
        try {
            const orderRes = await Apirequests(`leads/get-leads-new?q=${searchTerm}`,
                "GET",
                {},
                {
                    Authorization: `Bearer ${token}`,
                    lead_type: "quizlead"
                });

            // console.log(orderRes,'orderres')

            if (orderRes?.success) {
                setEqLeads(orderRes?.data)
            }
        } catch (error) {
            console.log(error, 'fetch quizlead error');
            return ErrorTost("Something went wrong. Try again later.")
        }
        setLoading({ state: false, name: "" })
    }

    const handleDeleteLead = async (id) => {
        setLoading({ state: true, name: "deletelead" });
        setdeleteId(id)
        try {
            const delRes = await Apirequests(`leads/delete-lead/${id}`, 'DELETE', { lead_type: "quizlead" }, {
                Authorization: `Bearer ${token}`,
            });
            if (delRes?.success) {
                SuccessTost(delRes?.message || "lead deleted successfully");
                setRefresh((prev) => !prev);
            } else {
                ErrorTost(delRes?.message)
            }
        } catch (error) {
            console.log(error, 'delete order error');
            ErrorTost("Something went wrong, please try again later. ")
        }
        setLoading({ state: false, name: "" })
    };

    useEffect(() => {
        fetchLeads();
    }, [refresh, token]);


    if (loading.state && loading.name === "fetchleads") {
        return <div className='h-screen w-full flex items-center justify-center bg-[rgba(255,255,255,0.5)]'>
            <SpinningLogo />
        </div>
    }

    return (
        <div>
            <CustomPageHeader
                title={"EQ Leads"}
                text={searchTerm}
                setText={setSearchTerm}
                handleSearch={handleSearch}
                onClick={() => setIsOffCanvasOpen({ state: true, name: "addlead" })}
                btnText={"Add Lead"}
                handleBackClick={() => navigate("/")}
                handleRefresh={handleRefresh}
                handleDownload={() => downloadExcel(EqLeads, 'eqleads')}
            />

            <main className="mx-auto py-6 sm:px-6 lg:px-8">
                <div className="px-4 py-6 sm:px-0">
                    <div className="overflow-x-auto">
                        <Table
                            tableHead={

                                <tr>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Whatsapp Number</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Score</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Crated At</th>
                                    <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                                </tr>
                            }
                            tableBody={
                                currentData?.map((lead, i) =>
                                    <tr key={i}>
                                        <td className="px-6 py-4 whitespace-nowrap">{lead?.name}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{lead?.email}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{lead?.whatsapp_number}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{lead?.score}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{lead?.status}</td>
                                        <td className="px-6 py-4 whitespace-nowrap">{moment(lead?.createdAt).format('DD-MM-YY hh:mm a')}</td>
                                        <td className="px-6 py-4 whitespace-nowrap flex gap-3">
                                            <button className='flex bg-red-200 rounded-lg px-3 py-2 items-center gap-1' onClick={() => handleDeleteLead(lead?._id)}>
                                                {
                                                    loading.state && loading.name === "deletelead" && deleteId === lead?._id ?
                                                        <BtnSpinner /> :
                                                        <>
                                                            <Trash className='text-red-700 text-sm' size={20} />
                                                            <span className='text-red-700 text-sm'>Delete</span>
                                                        </>
                                                }

                                            </button>

                                            {/* <button className='flex bg-gray-200 rounded-lg px-3 py-2 items-center gap-1' onClick={() => { setIsOffCanvasOpen({ state: true, name: "editorder" }); setCurrentOrder(order) }}><Edit3 size={18} /> Edit</button> */}
                                        </td>
                                    </tr>)
                            }
                        />
                    </div>
                </div>
                {EqLeads?.length ?
                    <div className="flex gap-x-2 items-center justify-between">
                        <p>total: {EqLeads?.length}</p>
                        <Pagination
                            page={currentPage}
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            onPageChange={handlePageChange}
                        />
                    </div> : null}
            </main>

            <CustomOffCanvas
                open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "addlead"}
                close={() => setIsOffCanvasOpen({ state: false, name: "" })}
                content={
                    <AddEqLead
                        close={() => setIsOffCanvasOpen({ state: false, name: "" })}
                        setRefresh={setRefresh}
                    />
                }
            />
        </div>
    )
}

export default EqTestLeads